"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react-aria-components';
import '../../../OverlayTrigger/components/MenuTrigger/MenuTrigger.mjs';
import { OverlayTrigger } from '../../../OverlayTrigger/OverlayTrigger.mjs';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';
import MenuTriggerView from '../../../../views/MenuTriggerView.mjs';

const ContextMenuTrigger = flowComponent(
  "ContextMenuTrigger",
  (props) => {
    const { children, ...triggerProps } = props;
    return /* @__PURE__ */ jsx(
      OverlayTrigger,
      {
        overlayType: "ContextMenu",
        ...triggerProps,
        component: MenuTriggerView,
        children
      }
    );
  }
);

export { ContextMenuTrigger, ContextMenuTrigger as default };
//# sourceMappingURL=ContextMenuTrigger.mjs.map
